import { Pipe, PipeTransform } from '@angular/core';
import {NICEDisposition} from "../models/NICE_Disposition.model";
import {NICEUser} from "../models/NICE_User.model";
import {NICESkill} from "../models/NICE_Skill.model";

@Pipe({ name: 'dispositionSearch' })
export class DispositionFilterPipe implements PipeTransform {
    public transform(dispositions: NICEDisposition[], searchText: any): any {
        dispositions = dispositions.sort((a, b) => a.dispositionName.localeCompare(b.dispositionName));
        if (searchText == null || dispositions == null) {
            return dispositions;
        }
        return dispositions.filter(disp => disp.dispositionName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    }
}

@Pipe({ name: 'userSearch' })
export class UserFilterPipe implements PipeTransform {
    sortByName(a,b) {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }
    public transform(users: NICEUser[], searchText: any, active: boolean): any {
        users = users.sort((a, b) => (a.firstName + a.lastName).localeCompare(b.firstName + b.lastName));
        if (searchText == null || users == null) {
            return users;
        }
        return users.filter((user) => {
                return (user.isActive == active) && (user.firstName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
                    user.lastName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
                    user.teamName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1)
                    ;
            }
        );
    }
}

@Pipe({ name: 'skillSearch' })
export class SkillFilterPipe implements PipeTransform {
    public transform(skills: NICESkill[], searchText: any): any {
        skills = skills.sort((a, b) => a.skillName.localeCompare(b.skillName));
        if (searchText == null || skills == null) {
            return skills;
        }
        return skills.filter((skill) => {
                return (skill.isActive = true) && (skill.skillName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
                    skill.campaignName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
                    skill.skillId.toString().toLowerCase().includes(searchText);
            }
        );
    }
}
